import { render, staticRenderFns } from "./FileViewerDialog.vue?vue&type=template&id=f70dd17e"
import script from "./FileViewerDialog.vue?vue&type=script&lang=js"
export * from "./FileViewerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports